<template>
  <span>
    <el-button type="primary" size="small" @click="select()" class="copy">{{buttonName}}</el-button>
    <el-dialog
      title="选择 渠道 / 推广位"
      :visible.sync="chooseOrgVisible"
      :close-on-click-modal="true"
      width="50%"
    >
      <el-cascader :props="props" @change="handleChange" filterable style="width:400px"></el-cascader>
      <div v-show="copyShow">{{ link }} <el-button type="primary" size="small" @click="copy(link)" class="copy">复制链接</el-button></div>
      <div id="qrcode" style="display:none"></div>
      <img :src="qrcodeImg" alt="" style="width:300px">
    </el-dialog>
  </span>
</template>

<script>
import { getChannelList, getChanelItemList, qrCode } from "@/api/common";
import Clipboard from 'clipboard';
export default {
  name: "copyLink",
  props: {
    url: {
      type: String,
      default: ""
    },
    buttonName: {
      type: String,
      default: ""
    },
  },
  data: function () {
    return {
      chooseOrgVisible:false,
      link:'',
      copyShow:false,
      qrcodeImg:'',
      props:{
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          if(level == 0){
            getChannelList().then(res => {
              if (res.code == 1) {
                resolve(res.data);
              }else{
                resolve([]);
              }
            })
          }
        
          if(level == 1){
            getChanelItemList({id:node.value}).then(res => {
              if (res.code == 1) {
                resolve(res.data);
              }else{
                resolve([]);
              }
            })
          }
        }
      }
    }
  },
  methods: {
    select(){
      this.chooseOrgVisible = true;
    },
    handleChange(value){
      this.link = this.url + value[1]
      this.copyShow = true
      this.qrcodeImg = qrCode(this.link)._oDrawing._elCanvas.toDataURL("image/png");
    },
    copy(url){
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return url
        }
      })
      clipboard.on('success', e => {
        this.$message({
          showClose: true,
          duration: 3000,
          message: '复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  }
}
</script>